module.exports = __webpack_public_path__ + "share-24.c00952be.svg";